import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    editContainer: {
        flexDirection: "row",
        alignContent:"center",
        alignItems: "stretch",
        justifyContent: "space-between"
    },
    campaignLogo: {
        width: "100%",
        aspectRatio: 0,
        height: 200
    },
    coverphoto: {
        position: "absolute",
        height: "100%",
        width: "100%",
        zIndex: 99,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    isApprovedContainer : {
        position: "absolute",
        height: "100%",
        width: "100%",
        zIndex: 800,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    isApprovedContent: {
        position: "absolute",
        zIndex: 999,
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center"
    },
    editButton: {
    },
    campaignTag: {
        position: "absolute"
    },
    campaignBottom: {
        position: "absolute",
        zIndex: 500
    }
});
export default stylesheet;
